import React, { useState } from "react";
import "./gallery.css";

function Poster({ url, likes, liked_by_user }) {
  return (
    <div className="poster relative mx-auto my-2 md:mx-4 md:my-4 shadow-md bg-white">
      <img className="" src={url} alt="" />
      <div className="absolute w-full h-full top-0 flex justify-center items-center text-4xl">
        <a className="inline-flex cursor-pointer text-white" href={url} download={`Poster-${new Date().getTime()}.jpg`} target="_blank">
          <i className="fa fa-download"></i>
        </a>
      </div>
    </div>
  );
}

function Gallery({ posters }) {
  // console.log(posters)
  return (
    <div className="gallery mt-8 flex flex-col md:flex-row md:flex-wrap md:justify-center">
      {posters.map((e, i) => (
        <Poster
          url={e.url}
          // likes={e.likes}
          // liked_by_user={e.liked_by_user}
          key={i}
        />
      ))}
    </div>
  );
}

export default Gallery;
